import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/bdotzour/Development/thorne-site-nuxt/src/layouts/default.vue").then(m => m.default || m)),
  take5daily: defineAsyncComponent(() => import("/Users/bdotzour/Development/thorne-site-nuxt/src/layouts/take5daily.vue").then(m => m.default || m))
}